import {
  Component,
  inject,
  HostListener,
  ElementRef,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Avatars } from '@mavles/shared';
import { AppService, UserApiService } from '@mavles/user';
import { MediaService } from '@mavles/shared';

import { ContactApiService, IContact } from '@mavles/contacts';
import { RouteDataService } from '@mavles/shared';

@Component({
  selector: 'app-menubar-layout',
  templateUrl: './menubar-layout.component.html',
  styleUrls: ['./menubar-layout.component.scss'],
  standalone: false,
})
export class MenubarLayoutComponent implements OnInit {
  userService = inject(UserApiService);
  protected appService: AppService = inject(AppService);
  private router = inject(Router);
  protected routeData = inject(RouteDataService);

  active = true;
  randomImg: any;
  avatars = Avatars;
  contacts: any[] = [];
  filteredContacts: any[] = [];
  selectedContactId: number | null = null;
  isProfileMenuOpen = false;

  protected mediaService = inject(MediaService);
  protected contactService = inject(ContactApiService);
  private eRef = inject(ElementRef);

  constructor() {
    this.randomImg = this.getRandomImage();
  }

  get currentRole(): string {
    const user = (this.appService.currentUser || this.appService.getActiveUser()) as any;
    if (!user) return '';

    if (user.is_admin === 1 || user.is_admin === true) {
      return 'Administrator';
    }

    if (Array.isArray(user.roles) && user.roles.length > 0) {
      const names = user.roles
        .map((r: any) => (typeof r === 'string' ? r : r?.name || r?.description))
        .filter(Boolean);
      if (names.length > 0) return names.join(', ');
    }

    if (typeof user.role === 'string') {
      return user.role;
    }

    return 'Staff';
  }

  get isAdmin(): boolean {
    return this.appService.isAdmin();
  }

  // Quick Action Handlers
  createInvoice() {
    this.routeData.createOrder('invoice');
  }

  createEstimate() {
    this.routeData.createOrder('estimate');
  }

  createPurchase() {
    this.routeData.createOrder('purchase');
  }

  createExpense() {
    this.routeData.createTransaction('vendor');
  }

  createCustomerPayment() {
    this.routeData.createTransaction('customer');
  }

  newCustomer() {
    this.routeData.newContact('customer');
  }

  newVendor() {
    this.routeData.newContact('vendor');
  }

  newLead() {
    this.routeData.newContact('lead');
  }

  newWorksheet() {
    this.routeData.createWorksheet('labour-group');
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isProfileMenuOpen = false;
    }
  }

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  ngOnInit() {
    this.contactService.contacts$.subscribe((data) => {
      this.contacts = (data || []).sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA; // descending
      });
      this.filteredContacts = [...this.contacts];
    });
  }

  onContactChange(contact: IContact) {
    this.routeData.viewContact(contact);
  }

  customSearchFn(term: string, contact: IContact) {
    const lowerTerm = term?.toLowerCase();
    const status =
      (contact.name && contact.name.toLowerCase().includes(lowerTerm)) ||
      // Ensure contact.phone is a string before calling toLowerCase() and includes()
      (contact.phone &&
        String(contact.phone).toLowerCase().includes(lowerTerm));
    return status;
  }

  private getRandomImage() {
    const randomImage =
      this.avatars[Math.floor(Math.random() * this.avatars.length)];
    return `assets/media/svg/avatars/${randomImage}`;
  }
}


